import React, { useState } from 'react';
import PropTypes from 'prop-types';

import styles from './TopTrending.module.scss';

const TopTrending = ({ products, className }) => {
  const [showProducts, setShowProducts] = useState(true);
  const expandButtonClass = showProducts ? 'fal fa-minus' : 'fal fa-plus';
  const toggleShowProducts = () => setShowProducts((prevState) => !prevState);

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.header}>
          <div className={styles.title}>
            <h1>Top Trending Picks</h1>
            <p>
              Our most popular items right now. Shop while they&apos;re hot!
            </p>
          </div>
          <div className={styles['button-container']}>
            <button
              type="button"
              className={`naked-button ${styles.button}`}
              onClick={toggleShowProducts}
            >
              <i className={expandButtonClass} />
            </button>
          </div>
        </div>
        {showProducts && (
          <ul className={`${className} ${styles.products}`}>{products}</ul>
        )}
      </div>
    </div>
  );
};

TopTrending.propTypes = {
  products: PropTypes.arrayOf(PropTypes.node).isRequired,
  className: PropTypes.string.isRequired,
};

export default TopTrending;
